import { ReactNode } from 'react'
import { TMNPortalHomePage } from './index'
import { TMNOcrSettingsPage } from './ocrSettings'

type PortalRoute = {
  path: string
  element: ReactNode
}

export const tmnPortalRoutes: PortalRoute[] = [
  {
    path: '/portal',
    element: <TMNPortalHomePage />,
  },
  {
    path: '/portal/ocr-settings',
    element: <TMNOcrSettingsPage />,
  },
]
